import React from "react";
import "./stages.css";
import CustomBtn from "../../components/CustomBtn/CustomBtn";
import Stage from "../../components/stage/Stage";
import { STAGE } from "../../constants/stages";

const Stages = () => {
  const displayStage = () => {
    return STAGE?.map((stageItem, index) => (
      <Stage
        btnText={stageItem.btnText}
        title={stageItem.title}
        subliner={stageItem.subliner}
        list={stageItem.list}
        footer={stageItem.footer}
        key={index}
      />
    ));
  };

  return (
    <div className="stages">
      <div className="stages_heroText">
        <p>
          Talent acquisition support that adapts as your company grows. Hire
          well at every stage.
        </p>
      </div>
      <div className="stages_stageContainer">{displayStage()}</div>
    </div>
  );
};

export default Stages;
